// extracted by mini-css-extract-plugin
module.exports = {"root":"Checkbox_root__A75Qj","disabled":"Checkbox_disabled__1Guqw","hidden":"Checkbox_hidden__3Wo6q","checkbox":"Checkbox_checkbox__1Zwy8"};